import axios from 'axios'
const url = '/empleados/dueño'

export default {
    create(data){
        return axios.post(url, data)
    },
    index(is_active){
        return axios.get(url+`?is_active=${is_active}`)
    },
   
    
    show(id) {
        return axios.get(`${url}/${id}`)
    },
    update(data) {
        return axios.put(`${url}/${data.id}`, data)
    },
   

}